import "./style.scss";
import * as React from "react";
import _ from "lodash";
import { Radio } from "antd";

interface ReportOptionProps {
  value: string;
  description: string;
  style?: any;
}

export const ReportOption = (props: ReportOptionProps) => (
  <Radio
    data-automation-id={`export-option-${props.value}`}
    style={{ ...props.style }}
    className="report-options"
    value={props.value}
  >
    <span className="title">{_.startCase(props.value)}</span>
    <div className="desc">{props.description}</div>
  </Radio>
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/DataExport/ReportOption.tsx